import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";

import MessageContent from "./MessageContent";
import MessageButtons from "./MessageButtons";
import MessageMediaActions from "./MessageMediaActions";

const MessageItem = ({
  message,
  onChangeMessageButtons,
  channel,
  disabledButtons,
  hideMediaConfigMenu = false,
  highlightIncomingMessage = false,
  onPickImage,
  onPickPdf,
  onReplaceMedia,
  onRemoveMedia,
  allowedButtonTypes,
}) => {
  if (!message) return null;
  
  const hasText = Boolean(message.content && message.content.trim());
  const isWhatsappApi = channel === "whatsapp_api";
  const isWhatsappLayout =
    channel === "whatsapp_api" || channel === "whatsapp_web" || channel === "sms";
  const canCustomizeMedia =
    isWhatsappApi && !Boolean(disabledButtons) && !Boolean(hideMediaConfigMenu);
  const nestedMessage =
    message.message && typeof message.message === "object"
      ? message.message
      : {};
  const header =
    message.header && typeof message.header === "object"
      ? message.header
      : nestedMessage.header && typeof nestedMessage.header === "object"
        ? nestedMessage.header
        : null;
  const hasMedia = isWhatsappApi
    ? Boolean(
        message.media ||
          message.medias ||
          message.attachments ||
          message.files ||
          message.attachment ||
          message.file ||
          message.image ||
          message.images ||
          message.document ||
          message.documents ||
          nestedMessage.media ||
          nestedMessage.medias ||
          nestedMessage.attachments ||
          nestedMessage.files ||
          nestedMessage.attachment ||
          nestedMessage.file ||
          nestedMessage.image ||
          nestedMessage.images ||
          nestedMessage.document ||
          nestedMessage.documents ||
          header?.content ||
          ["image", "img", "document", "pdf"].includes(String(header?.type || "").toLowerCase()) ||
          ["image", "document", "pdf"].includes(String(message.type || nestedMessage.type || "").toLowerCase()),
      )
    : false;
  const mediaKind = String(header?.type || message.type || nestedMessage.type || "").toLowerCase().includes("pdf")
    ? "pdf"
    : "image";

  if (message.fromMe && !hasText && !hasMedia && !isWhatsappLayout) {
    return null;
  }

  const mediaActionToolbar =
    message.fromMe && canCustomizeMedia ? (
      <MessageMediaActions
        messageId={message.id}
        onPickImage={onPickImage}
        onPickPdf={onPickPdf}
        onReplaceMedia={onReplaceMedia}
        onRemoveMedia={onRemoveMedia}
        hasMedia={hasMedia}
        mediaKind={mediaKind}
        floating={hasMedia}
        readOnly={Boolean(disabledButtons)}
      />
    ) : null;

  return (
    <Grid item xs={12}>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            ...(message.fromMe
              ? {
                  width: "100%",
                  pl: isWhatsappLayout ? 0 : 8,
                }
              : {
                  width: "fit-content",
                  maxWidth: "85%",
                }),
          }}
        >
          {isWhatsappLayout ? (
            <Box
              sx={{
                backgroundColor: message.fromMe
                  ? "#ffffff"
                  : highlightIncomingMessage
                    ? "#fff8e8"
                    : "#ffffff",
                borderRadius: 2.5,
                border: `1px solid ${message.fromMe ? "#e5eaf1" : highlightIncomingMessage ? "#f1ddae" : "#e5eaf1"}`,
                p: 1.5,
              }}
            >
              {!hasMedia && canCustomizeMedia && mediaActionToolbar}
              <MessageContent
                message={message}
                channel={channel}
                mediaActions={hasMedia && canCustomizeMedia ? mediaActionToolbar : null}
              />
            </Box>
          ) : (
            (hasText || hasMedia) && (
              <MessageContent
                message={message}
                channel={channel}
                mediaActions={null}
              />
            )
          )}

          {message.fromMe && channel === "whatsapp_api" && (
            <MessageButtons
              buttons={message.buttons || []}
              onChange={(newButtons) =>
                onChangeMessageButtons(message.id, newButtons)
              }
              channel={channel}
              readOnly={Boolean(disabledButtons)}
              allowedButtonTypes={allowedButtonTypes}
            />
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default MessageItem;
